// extracted by mini-css-extract-plugin
export default {"record":"record-wdQ80","condensed":"condensed-QiHu2"};